import { WidgetSizeT } from "../../../localTypes/WidgetSizeT";

export const kpiWidgetSizes: WidgetSizeT[] = [
  { w: 2, h: 1 },
  { w: 2, h: 2 },
];
